import { Link } from '@tanstack/react-router'
import { UserMenu } from './UserMenu'

export function AppShell({ children }: { children: React.ReactNode }) {
  return (
    <div className="min-h-screen bg-cream-50">
      <nav className="px-6 py-4 flex items-center justify-between border-b border-cream-200">
        <Link to="/" className="font-serif text-xl text-warm-gray-900">
          Fold & Flow
        </Link>
        <div className="flex items-center gap-6">
          <Link
            to="/"
            activeProps={{ className: 'text-terracotta-500 font-medium' }}
            inactiveProps={{ className: 'text-warm-gray-600 hover:text-warm-gray-800' }}
            className="text-sm transition-colors"
          >
            Home
          </Link>
          <UserMenu />
        </div>
      </nav>
      <main className="max-w-2xl mx-auto px-6 py-10">{children}</main>
    </div>
  )
}
